import { render, staticRenderFns } from "./province-selection.vue?vue&type=template&id=9fbb702c"
import script from "./province-selection.vue?vue&type=script&lang=ts"
export * from "./province-selection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports